import { render, staticRenderFns } from "./AuthorizationDetail.vue?vue&type=template&id=ba5cbae8&scoped=true"
import script from "./AuthorizationDetail.vue?vue&type=script&lang=js"
export * from "./AuthorizationDetail.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationDetail.vue?vue&type=style&index=0&id=ba5cbae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5cbae8",
  null
  
)

export default component.exports